import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useLocaleKeys } from '~/i18n';
import { FilterChip } from '../../FilterChip/FilterChip';
import { collectionOperatorLabel, summarizeCollectionPredicate } from './CollectionConditionChip.utils';
export const CollectionConditionChip = (param)=>{
    let { testId, fieldLabel, nounLabel, quantifier, predicate, toggleBiName, removeBiName, onToggleQuantifier, onRemove } = param;
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    const summary = summarizeCollectionPredicate(predicate, t);
    const isExistence = summary === '';
    const operatorLabel = isExistence ? quantifier === 'none' ? t.collectionExistsOperatorHasNo() : t.collectionExistsOperatorHas() : collectionOperatorLabel(quantifier, t);
    return /*#__PURE__*/ _jsx(FilterChip, {
        testId: testId,
        fieldLabel: isExistence ? '' : fieldLabel,
        operator: {
            label: operatorLabel,
            onToggle: onToggleQuantifier,
            biName: toggleBiName
        },
        valueLabel: isExistence ? nounLabel : summary,
        onRemove: onRemove,
        removeBiName: removeBiName,
        tone: "settings"
    });
};
